<div class="chart-container" *ngIf="plotlyData.length > 0">
  <plotly-plot
    [data]="plotlyData"
    [layout]="plotlyLayout"
    [config]="plotlyConfig"
    [useResizeHandler]="true"
    [style]="{position: 'relative', width: '100%', height: '100%'}">
  </plotly-plot>
</div>
